import React from 'react';
import AboutMainWrap from "../style/wrap";
import Container from "../../../../components/paper/container";
import SectionTitle from "../../../../components/heading/section";
import {Button, Card, Col, Row, Space} from "antd";
import CardTitle from "../../../../components/heading/card";
import ChartImage3 from '../../../../assets/img/tenanthome.png'
import ChartImage4 from '../../../../assets/img/tenant2.png'
import styled from "styled-components"
import {Icon} from '@iconify/react';
import AuthLayout from '../../../../layouts/auth.layout';
import HomeSlogan from "../../../home_1column/style/slogan";
import HomeSubtitle from "../../../home_1column/style/subtitle";

const AboutMain = () => {
    return (
        <AboutMainWrap>
            <Container>
                <Space direction='vertical' size={32} style={{width: '100%', paddingTop: '100px'}}>
                    <Row gutter={[32, 32]}>
                        <Col lg={{span: 2}} span={AuthLayout}>
                            
                        </Col>
                        <Col lg={{span: 3}} span={AuthLayout}>
                            
                        </Col>
                        <Col lg={{span: 7}} span={AuthLayout}>
                            <Space direction='vertical' style={{width: '100%'}} size={32}>
                                <div style={{
                                        minHeight: '60vh',
                                        position: 'relative',
                                        paddingTop: '0%',
                                    }}>
                                    <img src={ChartImage3} alt=""/>
                                    
                                </div>
                            </Space>
                        </Col>
                        <Col lg={{span: 7}} span={AuthLayout}>
                            <Space direction='vertical' style={{width: '100%'}} size={32}>
                                <div style={{
                                        minHeight: '60vh',
                                        position: 'relative',
                                        paddingTop: '0%',
                                    }}>
                                     
                                    {/* <img src={ChartImage4} alt=""/> */}
                                    
                                    {/* <HomeSlogan>
                                        Find A Home In One Click

                                        Apply To Rentals In One Click
                                    </HomeSlogan> */}
                                    <HomeSlogan>
                                        Apply To Rentals In One Click
                                    </HomeSlogan>
                                    <HomeSubtitle>
                                        No More Filling Forms, Handing Over Your ID & Paying Fees
                                        {/* Apply to Hundreds of Rentals In A Click No More Filling Endless Applications, Handing Your ID To Strangers & Throwing Money On Application Fees   */}
                                    </HomeSubtitle>

                                    <tr>
                                        <td>
                                            <a className="badge-link"
                                            href="#">
                                            <img className="wallet" style={{textAlign: 'center', marginTop: 5, height: 38, marginRight: 5, marginLeft: 58}}
                                            src="https://developer.apple.com/news/images/download-on-the-app-store-badge.png"
                                            alt="MOGUL"/></a>
                                        </td>
                                        <td>
                                            <a className="badge-link"
                                            href="#">
                                            <img className="wallet" style={{textAlign: 'center', marginTop: 5, height: 54, marginLeft: 5}}
                                            src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                                            alt="MOGUL"/></a>
                                        </td>
                                    </tr>
            
                                </div>
                            </Space>
                        </Col>
                        <Col lg={{span: 3}} span={AuthLayout}>
                            
                        </Col>
                        <Col lg={{span: 2}} span={AuthLayout}>
                            
                        </Col>
                    </Row>
                </Space>
            </Container>
        </AboutMainWrap>
    );
};

const ActionFormCard = styled(Card)`
  box-shadow: none;
  border: none;
  background: linear-gradient(to top, #f4e1ff, #f4e1ff);
  border-radius: 12px;
  padding: 0px;

  h2 {
    text-align: center;
    //font-size: 28px;
    margin-bottom: 0px;
  }

  h3 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 0px;
  }

  @media (max-width: 768px) {
    padding: 0;
  }
`

export default AboutMain;
